import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import RawButton from '../RawButton/index.js';
import RadioInput from '../RadioInput/index.js';
import styles from './styles.css.js';

function Scale(props) {
  const {
    label,
    name,
    onClick,
    value,
    className,
    color,
    inputName,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    disabled,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(RawButton, _extends({}, otherProps, {
    className: _cs(styles.scale, className, disabled && styles.disabled),
    style: value ? {
      borderColor: color
    } : undefined,
    name: name,
    onClick: onClick,
    title: label,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.innerCircle,
    style: {
      backgroundColor: color
    }
  }));
}

const MemoizedScale = genericMemo(Scale);

// eslint-disable-next-line @typescript-eslint/ban-types
function ScaleInput(props) {
  const {
    listContainerClassName,
    keySelector,
    labelSelector,
    colorSelector,
    className,
    hint,
    spacing = 'compact',
    ...otherProps
  } = props;
  const finalRendererParams = useCallback(option => ({
    color: colorSelector(option)
  }), [colorSelector]);
  return /*#__PURE__*/React.createElement(RadioInput, _extends({}, otherProps, {
    className: _cs(className, styles.scaleInput),
    renderer: MemoizedScale,
    spacing: spacing,
    rendererParams: finalRendererParams,
    listContainerClassName: _cs(listContainerClassName, styles.scaleList),
    keySelector: keySelector,
    labelSelector: labelSelector,
    hint: hint
  }));
}

var index = genericMemo(ScaleInput);

export { index as default };
//# sourceMappingURL=index.js.map
